import { Component, Attribute, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ServiceTermsComponent } from './serviceTerms/serviceTerms.component';
import { RequestFormComponent } from './requestForm/requestForm.component';
import { MakeAppointmentComponent } from './makeAppointment/makeAppointment.component';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;
declare var showServiceTermsLiferay: any; // Determina si se debe mostrar las condiciones del servicio
declare var showCardRequestLiferay: any; // Determina si se debe mostrar el formulario de solicitud de tarjeta

declare var showCardRequestError: any;

declare var portletNameCardRequestLiferay: any; // Nombre del portlet en Liferay
declare var actionURLLiferay: any; // URL de servicio
declare var dossierNumberSuccesss: any; //Mensaje de reclamación creada satisfactoriamente, muestra el número de dossier

declare var idCiudadLiferay: any;
declare var firstStep: any; //Indica si es el primer paso u otro posterior del proceso
declare var signupUserLiferay: any; // Indica si es necesario mostrar un mensaje advirtiendo de que se ha creado una cuenta                                     //nueva y es necesario iniciar sesion con las credenciales que se han enviado al usuario al correo

declare var jsonCardRequestLiferay: any;

declare var isSignedIn: any;

declare var getPDFAction: any;

declare var DoesLiferayUserExist: any;

declare var IsEmailOrCinDuplicate: any;

declare var CreateOrUpdateCardRequest: any;

declare var showMakeAppointment: any;
declare var showMassarField: any;
declare var mandatoryMassarFieldByCardSelectedId: any;

declare var showCreateButton: any;

declare var enableCardRequestForm: any;

declare var recaptchaKey: string;
/*--------------------------------------------- Variables Globales ---------------------------------------------*/
@Component({
    selector: 'app-solicitud-tarjeta',
    templateUrl: './solicitud-tarjeta.component.html',
    styleUrls: ['./solicitud-tarjeta.component.css']
})

export class AppComponent implements OnInit {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = i18nVS;
    actionForm = ''; // Action del formulario
    portletName = ''; // Nombre del portlet
    getPDFAction = getPDFAction;
    recaptchaKey = recaptchaKey;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @ViewChild(ServiceTermsComponent) serviceTerms: ServiceTermsComponent;
    @ViewChild(RequestFormComponent) requestForm: RequestFormComponent;
    @ViewChild(MakeAppointmentComponent) makeAppointment: MakeAppointmentComponent;
    @Input() languageId: string;
    @Input() maxDateInMilis: number;

    // Muestra o bien los terminos de servicio o bien el formulario
    showServiceTerms = false;

    cardRequestCompledClass = 'invisible';
    cardRequestErrorClass = 'invisible';
    cardRequestSearchErrorClass = 'invisible';
    signupMessageClass = 'invisible';
    spinnerClass = "invisible";

    cityId = '';
    jsonData = '';
    dossierSuccess = '';
    displayError = '';

    needLogin = false;
    sessionCloseResponse = null;

    generalError = "";

    // Clase que muestra y oculta el pop up
    popUpClass = "invisible";
    // Texto del pop up
    popUpMessage = "";
    // El ID del modo en el que estan las funciones de aceptar del pop up
    popUpAceptFunctionMode = 0;

    // Si esta a true nos indicaria que ya no queda nada por hacer con este dossier por lo tanto no se le permitira al usuario interactuar con el
    allDone = false;
    numero_carte = "";

    showMakeAppointment = showMakeAppointment;
    showMassarField = showMassarField;
    mandatoryMassarFieldByCardSelectedId = mandatoryMassarFieldByCardSelectedId;

    showCreateButton = showCreateButton;

    loadPDFClass = "invisible";
    submitButtonLabel = this.i18nL.form_enviar

    botonIzquierdo = this.i18nL.general_cancelar;
    botonIzquierdoClass = "";
    disabledDates: string[];
    enableCardRequestForm: boolean;
    userExists: boolean;

    // reCaptcha
    recaptcha: boolean

    onScriptLoad() {
        console.log('Google reCAPTCHA loaded');
    }

    onScriptError() {
        console.log('Something went long when loading the Google reCAPTCHA')
        this.recaptcha = true
    }
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    private readData(url): Observable<Response> {
        return this.http.post(url, new Map<string, string>());
    }

    private proccessError(displayMsg, debugMsg, url) {
        this.cardRequestSearchErrorClass = '';
        this.displayError = (displayMsg != null) ? displayMsg : this.i18nL['zz03_error_card_recuest_search'];
        console.log('Error: ' + debugMsg + "[" + url + "]");
    }

    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
    private validateCardRequest(res: Response, url: string) {
        this.spinnerClass = 'invisible';

        try {
            this.jsonData = res.json();
        } catch (error) {
            console.log(res);
            this.proccessError(this.i18nL['zz03_error_card_recuest_search'], error, url);
        }
    }

    private validateSessionCloseRequest(res: Response, url: string) {
        try {
            this.sessionCloseResponse = res.text();
        } catch (error) {
            console.log(res);
            this.proccessError(this.i18nL['zz03_error_card_recuest_search'], error, url);
        }
    }

    private proccessCardReCuestError(jsonCardRequest) {
        try {
            var student = JSON.parse(jsonCardRequest);
            if (student.errorMessage != undefined && student.errorMessage != "" && student.errorMessage != null) {
                this.proccessError(student.errorMessage, student.errorMessage, "");
            }
        } catch (except) { }
    }

    public validateForm() {
        var formValidate = this.requestForm.validateCardRequestForm();
        if (showMakeAppointment && formValidate) {
            formValidate = this.makeAppointment.validateAppointmentForm();
        }
        return formValidate;
    }

    public errorManager(errorMessage: string) {
        this.cardRequestErrorClass = 'invisible';
        this.cardRequestSearchErrorClass = 'invisible';
        if (errorMessage != null) {
            this.displayError = errorMessage;
            this.cardRequestSearchErrorClass = '';
        }
    }

    public onSubmitForm() {
        this.onGeneralError("");
        var inNewCard = true;
        if (this.requestForm.solicitud.getId() != null) {
            inNewCard = false;
        }
        if (inNewCard) {
            if (this.validateForm()) {
                // Comprobamos si el email o el cin ya existen
                this.checkIfEmailOrCinDuplicate();
            } else {
                //Cuando se produce un error, por ejemplo seleccionar 2 lineas iguales, se emite un error que lo captura el validateForm
                //Al enviar el validateForm como false, si no comprobamos el mensaje del generalError, nos saldria siempre el de rellenar datos obligatorios
                if (this.generalError == null) {
                    this.popUpClass = "";
                    this.botonIzquierdoClass = "invisible";
                    this.popUpMessage = i18nVS.form_cardRequest_rellena_datos_obligatorios;
                    //Seteamos a 0 puesto que si pasa las validaciones pero anulamos la creación de la tarjeta, nos llega con valor "2"
                    //Lo que provoca que en la siguiente comprobación, si hay campos vacíos, después de aceptar el popUp crea la tarjeta con los campos vacíos
                    this.popUpAceptFunctionMode = 0;
                } else {
                    this.popUpClass = "";
                    this.botonIzquierdoClass = "invisible";
                    this.popUpMessage = this.generalError;
                    //Seteamos a 0 puesto que si pasa las validaciones pero anulamos la creación de la tarjeta, nos llega con valor "2"
                    //Lo que provoca que en la siguiente comprobación, si hay campos vacíos, después de aceptar el popUp crea la tarjeta con los campos vacíos
                    this.popUpAceptFunctionMode = 0;
                }
            }
        } else {
            // Si el formulario valida
            if (this.validateForm()) {
                this.sendCardRequestForm();
            } else {
                //Cuando se produce un error, por ejemplo seleccionar 2 lineas iguales, se emite un error que lo captura el validateForm
                //Al enviar el validateForm como false, si no comprobamos el mensaje del generalError, nos saldria siempre el de rellenar datos obligatorios
                if (this.generalError == null) {
                    this.popUpClass = "";
                    this.botonIzquierdoClass = "invisible";
                    this.popUpMessage = i18nVS.form_cardRequest_rellena_datos_obligatorios;
                    //Seteamos a 0 puesto que si pasa las validaciones pero anulamos la creación de la tarjeta, nos llega con valor "2"
                    //Lo que provoca que en la siguiente comprobación, si hay campos vacíos, después de aceptar el popUp crea la tarjeta con los campos vacíos
                    this.popUpAceptFunctionMode = 0;
                } else {
                    this.popUpClass = "";
                    this.botonIzquierdoClass = "invisible";
                    this.popUpMessage = this.generalError;
                    //Seteamos a 0 puesto que si pasa las validaciones pero anulamos la creación de la tarjeta, nos llega con valor "2"
                    //Lo que provoca que en la siguiente comprobación, si hay campos vacíos, después de aceptar el popUp crea la tarjeta con los campos vacíos
                    this.popUpAceptFunctionMode = 0;
                }
            }
        }
        return false;
    }

    // Comprobamos si el usuario o el cin ya existen
    public checkIfEmailOrCinDuplicate() {
        let cinInput = (<HTMLInputElement>document.getElementById(this.portletName + 'cin'));
        let emailInput = (<HTMLInputElement>document.getElementById(this.portletName + 'email'));
        let birthDateInput = (<HTMLInputElement>document.getElementById(this.portletName + 'birthdate'));

        if (this.requestForm.isMandatory(cinInput) && this.requestForm.isMandatory(emailInput)) {
            this.checkIfLiferayUserExist();
            let urlLLamada = IsEmailOrCinDuplicate + "&" + this.portletName + "cin=" + cinInput.value + "&" + this.portletName + "birthDate=" + birthDateInput.value + "&" + this.portletName + "email=" + emailInput.value;
            this.http.post(urlLLamada, new Map<string, string>()).subscribe(
                res => { this.checkIfEmailOrCinExistsResponse(res) }
            );
        }
    }

    public checkIfLiferayUserExist() {
        let emailInput = (<HTMLInputElement>document.getElementById(this.portletName + 'email'));
        let urlLLamada = DoesLiferayUserExist + "&" + this.portletName + "email=" + emailInput.value;
        this.http.post(urlLLamada, new Map<string, string>()).subscribe(res => { this.checkIfLiferayUserExistResponse(res) });
    }

    public checkIfLiferayUserExistResponse(res) {
        this.userExists = JSON.parse(res._body);
    }

    /**
     * Maneja los casos en los que se puede o no grabar la solicitud de tarjeta del usuario, dependiendo de:
     *  - Si existen tarjetas de cursos anteriores o del curso actual
     *  - Si existe una cuenta registrada con el email introducido en el formulario
     *  - Si se ha logueado o no
     * 
     * @param res Respuesta de IsEmailOrCinDuplicate:
     * 0 si no se encuentra ninguna tarjeta registrada al usuario, 
     * 1 si se encuentra del curso anterior, 
     * 2 si se encuentra del curso actual
     */
    public checkIfEmailOrCinExistsResponse(res) {
        if (res._body === "-1") {
            this.showInvalidData();
            return;
        }
        if (res._body === "0") {
            if (!isSignedIn) {
                if (this.userExists === false) {
                    // Sin tarjeta, no logueado, no existe cuenta: creamos nueva cuenta y tarjeta del curso actual
                    this.showCreateAccountAndCardPopUp();
                } else {
                    // Sin tarjeta, no logueado, existe cuenta: le pedimos login para repetir el proceso logueado
                    this.showLoginPopUp();
                }
            } else {
                // Sin tarjeta, logueado, creamos solo tarjeta del curso actual
                this.showCreateCardPopUp();
            }
        } else if (res._body === "1") {
            if (!isSignedIn) {
                // Este caso no deberia darse, ya que un usuario con tarjeta del curso anterior siempre deberia existir
                if (this.userExists === false) {
                    // Con tarjeta del curso anterior, no logueado, no existe cuenta: creamos nueva cuenta y tarjeta del curso actual
                    this.showCreateAccountAndCardPopUp();
                } else {
                    // Con tarjeta del curso anterior, no logueado, existe cuenta: le pedimos login para repetir el proceso logueado
                    this.showLoginPopUp();
                }
            } else {
                // Con tarjeta del curso anterior, logueado, creamos solo tarjeta del curso actual
                this.showCreateCardPopUp();
            }
        } else { // res._body === "2"
            // Encontramos tarjeta del curso actual, login
            this.showLoginPopUp();
        }
    }

    private showInvalidData() {
        // Mostrar pop up de CIN incorrecto
        this.popUpClass = "";
        this.popUpMessage = this.i18nL.form_caracteres_especiales_cin;
        // popup modo 2: mandar el formulario
        this.popUpAceptFunctionMode = 0;
    }

    private showCreateAccountAndCardPopUp() {
        // Mostrar pop up de con tus datos se creara una cuenta
        this.popUpClass = "";
        this.popUpMessage = this.i18nL.zz04_popUps_creacionUsuarios;
        // popup modo 2: mandar el formulario  
        this.popUpAceptFunctionMode = 2;
    }

    private showCreateCardPopUp() {
        // Mostrar pop up de con tus datos se creara una cuenta
        this.popUpClass = "";
        // popup modo 2: mandar el formulario  
        this.popUpAceptFunctionMode = 2;
        this.popUpMessage = this.i18nL.zz04_popUps_solicitudCorrecta;
    }

    private showLoginPopUp() {
        this.popUpClass = "";
        this.popUpMessage = this.i18nL.zz04_popUps_emailOCinDuplicados;
        // popup modo 1: se necesita loguearse
        this.popUpAceptFunctionMode = 1;
    }

    // Hace submit del formulario
    public sendCardRequestForm() {
        this.spinnerClass = '';
        // Intentamos crear o actualizar una solicitud de tarjeta
        var urlLLamada = CreateOrUpdateCardRequest;

        var id = null;
        var code = null;
        var dossierNumber = null;

        // Si esta vacio significa que es una tarjeta nueva y no una actualizacion de una tarjeta
        if (this.requestForm.solicitud.getId() != null && this.requestForm.solicitud.getId() != "" && typeof this.requestForm.solicitud.getId() != "undefined") {
            id = this.requestForm.solicitud.getId();
            code = this.requestForm.solicitud.getCode();
            dossierNumber = this.requestForm.cardRequest.numero_carte;
        }

        var typeCarteId = (<HTMLInputElement>document.getElementById(this.portletName + 'typeCarteId')).value;
        var name = (<HTMLInputElement>document.getElementById(this.portletName + 'name')).value;
        var surname = (<HTMLInputElement>document.getElementById(this.portletName + 'surname')).value;
        var CIN = (<HTMLInputElement>document.getElementById(this.portletName + 'cin')).value
        var birthDate = (<HTMLInputElement>document.getElementById(this.portletName + 'birthdate')).value;
        var address = (<HTMLInputElement>document.getElementById(this.portletName + 'address')).value;
        var phone = (<HTMLInputElement>document.getElementById(this.portletName + 'phone')).value;
        var email = (<HTMLInputElement>document.getElementById(this.portletName + 'email')).value;

        var schoollevel = (<HTMLInputElement>document.getElementById(this.portletName + 'schoollevel')).value;
        var schoollevel_SelectedIndex = (<HTMLSelectElement>document.getElementById(this.portletName + 'schoollevel')).selectedIndex;
        var schoollevel_name = "";
        if (schoollevel_SelectedIndex != -1) {
            schoollevel_name = document.getElementById(this.portletName + 'schoollevel')[schoollevel_SelectedIndex].text;
        }

        var etablissement = (<HTMLInputElement>document.getElementById(this.portletName + 'etablissement')).value;
        var etablissement_SelectedIndex = (<HTMLSelectElement>document.getElementById(this.portletName + 'etablissement')).selectedIndex;
        var etablissement_name = "";
        if (etablissement_SelectedIndex != -1) {
            etablissement_name = document.getElementById(this.portletName + 'etablissement')[etablissement_SelectedIndex].text;
        }

        var contador = 0;
        var idLines = "";
        while (<HTMLInputElement>document.getElementById(this.portletName + 'idLine' + contador) != null) {
            var lineValue = (<HTMLInputElement>document.getElementById(this.portletName + 'idLine' + contador)).value;
            if (lineValue != "-1" && lineValue != "") {
                if (idLines) {
                    idLines += ":";
                }
                idLines += (<HTMLInputElement>document.getElementById(this.portletName + 'idLine' + contador)).value;
            }
            contador++;
        }

        var cityId = idCiudadLiferay;

        var province = (<HTMLInputElement>document.getElementById(this.portletName + 'province')).value;
        var province_SelectedIndex = (<HTMLSelectElement>document.getElementById(this.portletName + 'province')).selectedIndex;
        var province_name = "";
        if (province_SelectedIndex != -1) {
            province_name = document.getElementById(this.portletName + 'province')[province_SelectedIndex].text;
        }

        var commune = (<HTMLInputElement>document.getElementById(this.portletName + 'commune')).value;
        var commune_SelectedIndex = (<HTMLSelectElement>document.getElementById(this.portletName + 'commune')).selectedIndex;
        var commune_name = "";
        if (commune_SelectedIndex != -1) {
            commune_name = document.getElementById(this.portletName + 'commune')[commune_SelectedIndex].text;
        }

        var zone = (<HTMLInputElement>document.getElementById(this.portletName + 'zone')).value;
        var traitement = (<HTMLInputElement>document.getElementById(this.portletName + 'traitement')).value;

        urlLLamada = urlLLamada + "&" + this.portletName + "id=" + id;
        urlLLamada = urlLLamada + "&" + this.portletName + "code=" + code;
        urlLLamada = urlLLamada + "&" + this.portletName + "dossierNumber=" + dossierNumber;
        urlLLamada = urlLLamada + "&" + this.portletName + "type_carte_id=" + typeCarteId;
        urlLLamada = urlLLamada + "&" + this.portletName + "nom=" + name;
        urlLLamada = urlLLamada + "&" + this.portletName + "prenom=" + surname;
        urlLLamada = urlLLamada + "&" + this.portletName + "CIN=" + CIN;
        urlLLamada = urlLLamada + "&" + this.portletName + "birthDate=" + birthDate;
        urlLLamada = urlLLamada + "&" + this.portletName + "address=" + address;
        urlLLamada = urlLLamada + "&" + this.portletName + "tel=" + phone;
        urlLLamada = urlLLamada + "&" + this.portletName + "email=" + email;
        urlLLamada = urlLLamada + "&" + this.portletName + "schoollevel=" + schoollevel;
        urlLLamada = urlLLamada + "&" + this.portletName + "schoollevel_name=" + schoollevel_name;
        urlLLamada = urlLLamada + "&" + this.portletName + "etablissement=" + etablissement;
        urlLLamada = urlLLamada + "&" + this.portletName + "etablissement_name=" + etablissement_name;
        urlLLamada = urlLLamada + "&" + this.portletName + "idLine0=" + idLines;
        urlLLamada = urlLLamada + "&" + this.portletName + "cityId=" + cityId;
        urlLLamada = urlLLamada + "&" + this.portletName + "province=" + province;
        urlLLamada = urlLLamada + "&" + this.portletName + "province_name=" + province_name;
        urlLLamada = urlLLamada + "&" + this.portletName + "commune=" + commune;
        urlLLamada = urlLLamada + "&" + this.portletName + "commune_name=" + commune_name;
        urlLLamada = urlLLamada + "&" + this.portletName + "zone=" + zone;
        urlLLamada = urlLLamada + "&" + this.portletName + "traitement=" + traitement;
        // Datos de la parte del Make Apointment
        if (showMakeAppointment) {
            var agency = (<HTMLSelectElement>document.getElementById(this.portletName + 'agency')).value;
            var fromStringToDate = this.makeAppointment.selectedDate;
            var dateAppointment = fromStringToDate.toISOString();
            var schedule = (<HTMLInputElement>document.getElementById(this.portletName + 'schedule')).value;
            urlLLamada = urlLLamada + "&" + this.portletName + "agence=" + agency;
            urlLLamada = urlLLamada + "&" + this.portletName + "daterdv=" + dateAppointment;
            urlLLamada = urlLLamada + "&" + this.portletName + "heure=" + schedule;
        }

        if (showMassarField && idCiudadLiferay != '2') {
            var massar = (<HTMLInputElement>document.getElementById(this.portletName + 'massar')).value;
            urlLLamada = urlLLamada + "&" + this.portletName + "massar=" + massar;
        }
        this.http.post(urlLLamada, new Map<string, string>()).subscribe(
            res => { this.checkIfCardWasSuccesfullyCreated(res) }
        );
    }

    public checkIfCardWasSuccesfullyCreated(res) {
        //Si hay un error
        if (res.json().error != undefined && res.json().codigo != undefined) {
            this.checkError(res);
        }
        //si la creacion o edicion fue bien
        else {
            this.checkSuccess(res);
        }
    }

    public checkError(res) {
        if (res.json().error != undefined && res.json().codigo != undefined) {
            this.popUpClass = "";
            if (res.json().codigo == 'usr') {
                //si ya existe el usuario liferay con ese email, al crear la tarjeta
                this.popUpMessage = this.i18nL.zz06_popUp_error_email_liferay_exist;
                this.botonIzquierdoClass = "invisible";
                this.popUpAceptFunctionMode = 1;
            }
            else {
                //cualquier otro error en la creacion o actualizacion de la tarjeta
                this.popUpMessage = this.i18nL.nearby_error_inesperado;
            }
        }
    }

    public checkSuccess(res) {
        // En caso de que se haya creado una nueva requestCard con exito
        // Si esta vacio significa que es una tarjeta nueva y no una actualizacion de una tarjeta
        if (this.requestForm.solicitud.getId() != null && this.requestForm.solicitud.getId() != "" && typeof this.requestForm.solicitud.getId() != "undefined") {
            this.requestForm.cardRequest = res.json();
            this.popUpClass = "";
            this.botonIzquierdoClass = "invisible";
            this.popUpMessage = this.i18nL.form_cardRequest_datos_tarjeta_guardados_correctamente;
        }
        else if (res.json().id != undefined) {
            // Una vez completado el tramite se permite descargar el PDF
            this.requestForm.blockField = true;
            this.requestForm.cardRequest = res.json();
            this.popUpClass = "";
            this.popUpAceptFunctionMode = 3;
            this.botonIzquierdo = this.i18nL.zz03_descargar;
            this.botonIzquierdoClass = "btn-blue";

            // Si se esta logueado
            if (isSignedIn) {
                this.requestForm.solicitud.setId(res.json().id);
                this.requestForm.solicitud.setCode(res.json().code);
                this.popUpMessage = this.i18nL.zz01_cardRequest_success;
                this.loadPDFClass = "";
                this.submitButtonLabel = this.i18nL.general_guardarCambios;
            } else { // Si no lo esta
                this.popUpMessage = this.i18nL.zz01_cardRequest_success + ': ' + this.i18nL.zz03_signup_advice + ", " + this.i18nL.zz03_need_login_advice;
            }
        }
    }

    //Metodo para crear la URl de invocacion al ajax de generar el PDF.
    //Crea la URl del ajax y la invoca con un click
    public loadPDFFile() {
        var email = this.requestForm.cardRequest.email;
        var code = this.requestForm.cardRequest.code;
        var finalUrl = this.getPDFAction;
        finalUrl += this.concatForUrl("email", email);
        finalUrl += this.concatForUrl("code", code);

        var downloadLink = document.createElement('a');
        // Abrimos en una nueva pestaña
        downloadLink.target = "_blank";
        downloadLink.href = finalUrl;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }

    private concatForUrl(attributeText: String, attributeValue) {
        return "&" + this.portletName + attributeText + "=" + attributeValue
    }

    // Funciones de aceptar y cancelar del popUp
    popUpCancelFunction() {
        this.popUpClass = "invisible";
        this.popUpMessage = "";
        this.spinnerClass = 'invisible';
        this.botonIzquierdo = this.i18nL.general_cancelar;
        this.botonIzquierdoClass = "";

        // En este caso se realizara la accion de descargar el PDF
        if (this.popUpAceptFunctionMode == 3) {
            this.loadPDFFile()
        }
    }

    // 1: se necesita loguearse
    // 2: mandar el formulario
    popUpAceptFunction() {
        this.popUpClass = "invisible";
        this.popUpMessage = "";
        this.spinnerClass = 'invisible';
        this.botonIzquierdo = this.i18nL.general_cancelar;
        this.botonIzquierdoClass = "";

        if (this.popUpAceptFunctionMode == 1) {
            document.getElementById("signInDropDown").click();
        }
        if (this.popUpAceptFunctionMode == 2) {
            document.getElementById("aceptarPopUp").setAttribute('disabled', '');
            this.sendCardRequestForm();
            document.getElementById("aceptarPopUp").removeAttribute('disabled');
        }
    }

    // No solo muestra el formulario de citas, tambien lo inicializa a partir del objeto this.requestForm.cardRequest
    mostrarMakeAppointment() {
        this.makeAppointment.mostrarEstaSeccion(this.requestForm.cardRequest);
        this.requestForm.blockField = true;
    }

    // Comprobamos si ya no es posible interactuar con una tarjeta pues si ya le han asignado un numero de tarjeta no se pueden modificar sus datos
    checkIfCardProcesIsComplete() {
        var card = this.requestForm.cardRequest;
        if ((card.numero_carte != null && card.numero_carte != "null") || (card.num_carte_etudiant != null && card.num_carte_etudiant != "null")
            || (card.num_carte_duplicata != null && card.num_carte_duplicata != "null") || (card.numero_carte_3 != null && card.numero_carte_3 != "null")) {
            if (card.numero_carte != null && card.numero_carte != "null") {
                this.numero_carte = card.numero_carte;
            }
            if (card.num_carte_etudiant != null && card.num_carte_etudiant != "null") {
                this.numero_carte = card.num_carte_etudiant;
            }
            if (card.num_carte_duplicata != null && card.num_carte_duplicata != "null") {
                this.numero_carte = card.num_carte_duplicata;
            }
            if (card.numero_carte_3 != null && card.numero_carte_3 != "null") {
                this.numero_carte = card.numero_carte_3;
            }
            return true;
        } else {
            return false;
        }
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    onFullyLoaded(dossierYaAsociado) {
        // En caso de que este usuario ya tenga un dosier asociado
        if (dossierYaAsociado) {
            // Comprobamos si no quedan mas tramites por hacer con este dossier para este usuario
            if (this.checkIfCardProcesIsComplete()) {
                this.allDone = true;
            }
            this.mostrarMakeAppointment();
            this.loadPDFClass = '';
            this.submitButtonLabel = this.i18nL.general_guardarCambios;
        }
    }

    ngOnInit() {
        this.showServiceTerms = showServiceTermsLiferay;
        this.portletName = portletNameCardRequestLiferay;
        this.actionForm = actionURLLiferay;
        this.dossierSuccess = dossierNumberSuccesss;
        this.signupMessageClass = (signupUserLiferay) ? '' : 'invisible';
        this.proccessCardReCuestError(jsonCardRequestLiferay);
        this.enableCardRequestForm = enableCardRequestForm;
    }

    onGeneralError(errorDisplay: string): void {
        this.generalError = errorDisplay;
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http, elm: ElementRef) {
        this.languageId = elm.nativeElement.getAttribute('languageId');
        this.maxDateInMilis = elm.nativeElement.getAttribute('maxDateInMilis');
    }
}



// WEBPACK FOOTER //
// ./src/app/solicitud-tarjeta.component.ts